export default "__VITE_ASSET__f78186f3__"